import { QnAWritePage } from "../../Write/QnAWritePage";

export const QnAEdit = () => <QnAWritePage mode="edit" />;
